import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

@Component({ name: "AddFavorite" })
export default class AddFavorite extends Vue {
    public localizer: any = Localizer;
    public isLoading: boolean = false;
    public isFavorite: boolean = false;
    public validationErrors: any[] = [];

    @Prop() readonly itemIdMaster: string;
    @Prop() readonly isAuthenticated: boolean;

    @Watch("favorites") onFavoritesChanged() {
        this.isFavorite = this.favorites.some(x => x.idMaster === this.itemIdMaster);
    }

    get favorites() {
        return this.$store.getters["favoriteStore/favorites"];
    }

    get routes() {
        return (<any>window).App.routes;
    }

    public created() {
        this.isFavorite = this.favorites.some(x => x.idMaster === this.itemIdMaster);
    }

    public async setFavorite(e: any) {
        e.preventDefault();
        if (this.isFavorite) {
            await this.removeFavorite();
        } else {
            await this.addFavorite();
        }
    }

    public async addFavorite() {
        FormHelper.removeFocus();
        this.validationErrors = [];
        this.isLoading = true;

        try {
            await Axios.post(this.routes.SearchDigitalCatalogue_SetFavorite, { itemIdMaster: this.itemIdMaster });

            this.$store.dispatch("favoriteStore/getFavorites");

            GTagHelper.sendEvent("click", "texture_favorite", "add");
        } catch (error) {
            if (error.response && error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }

        this.isLoading = false;
    }

    public async removeFavorite() {
        FormHelper.removeFocus();
        this.validationErrors = [];
        this.isLoading = true;

        try {
            await Axios.post(this.routes.SearchDigitalCatalogue_RemoveFavorite, { itemIdMaster: this.itemIdMaster });

            this.$store.dispatch("favoriteStore/getFavorites");

            GTagHelper.sendEvent("click", "texture_favorite", "remove");
        } catch (error) {
            if (error.response && error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }

        this.isLoading = false;
    }
};